import React from "react";

import { Avatar, Grid, Theme, Typography, makeStyles } from "@material-ui/core";

import { AreaAvatarProps } from "./types";

const useStyles = makeStyles<Theme, { avatarColor: string }>(() => ({
  avatar: ({ avatarColor }) => ({
    backgroundColor: avatarColor,
  }),
}));

const AreaAvatar: React.FC<AreaAvatarProps> = ({
  label,
  initials,
  color = "#3DC0DB",
}) => {
  const classes = useStyles({ avatarColor: color });

  return (
    <Grid container direction="row" alignItems="center" spacing={1}>
      <Grid item>
        <Avatar className={classes.avatar} data-test={`area-card-avatar`}>
          {initials}
        </Avatar>
      </Grid>
      <Grid item>
        <Typography data-test={`area-card-avatar-label`} variant="subtitle2">
          {label}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AreaAvatar;
